(() => {
  const translations = {
    it: {
      title: 'Traccia il tuo ordine',
      orderTab: 'Numero d’ordine',
      trackingTab: 'Numero di spedizione',
      orderPlaceholder: 'Numero d’ordine',
      emailPlaceholder: 'Email',
      trackingPlaceholder: 'Numero di spedizione',
      button: 'Traccia',
      loading: 'Ricerca in corso…'
    },
    en: {
      title: 'Track your order',
      orderTab: 'Order number',
      trackingTab: 'Tracking number',
      orderPlaceholder: 'Order number',
      emailPlaceholder: 'Email',
      trackingPlaceholder: 'Tracking number',
      button: 'Track',
      loading: 'Searching…'
    },
    de: {
      title: 'Bestellung verfolgen',
      orderTab: 'Bestellnummer',
      trackingTab: 'Sendungsnummer',
      orderPlaceholder: 'Bestellnummer',
      emailPlaceholder: 'E-Mail',
      trackingPlaceholder: 'Sendungsnummer',
      button: 'Verfolgen',
      loading: 'Suche läuft…'
    },
    fr: {
      title: 'Suivre votre commande',
      orderTab: 'Numéro de commande',
      trackingTab: 'Numéro de suivi',
      orderPlaceholder: 'Numéro de commande',
      emailPlaceholder: 'E-mail',
      trackingPlaceholder: 'Numéro de suivi',
      button: 'Suivre',
      loading: 'Recherche en cours…'
    },
    es: {
      title: 'Rastrear tu pedido',
      orderTab: 'Número de pedido',
      trackingTab: 'Número de seguimiento',
      orderPlaceholder: 'Número de pedido',
      emailPlaceholder: 'Correo electrónico',
      trackingPlaceholder: 'Número de seguimiento',
      button: 'Rastrear',
      loading: 'Buscando…'
    },
    pt: {
      title: 'Acompanhar a sua encomenda',
      orderTab: 'Número da encomenda',
      trackingTab: 'Número de rastreio',
      orderPlaceholder: 'Número da encomenda',
      emailPlaceholder: 'E-mail',
      trackingPlaceholder: 'Número de rastreio',
      button: 'Acompanhar',
      loading: 'A pesquisar…'
    },
    nl: {
      title: 'Volg je bestelling',
      orderTab: 'Bestelnummer',
      trackingTab: 'Track-en-tracecode',
      orderPlaceholder: 'Bestelnummer',
      emailPlaceholder: 'E-mail',
      trackingPlaceholder: 'Track-en-tracecode',
      button: 'Volgen',
      loading: 'Bezig met zoeken…'
    },
    pl: {
      title: 'Śledź zamówienie',
      orderTab: 'Numer zamówienia',
      trackingTab: 'Numer przesyłki',
      orderPlaceholder: 'Numer zamówienia',
      emailPlaceholder: 'E-mail',
      trackingPlaceholder: 'Numer przesyłki',
      button: 'Śledź',
      loading: 'Wyszukiwanie…'
    }
  };

  const locale = (
    window.Shopify?.locale ||
    document.documentElement.lang ||
    'it'
  ).toLowerCase().split('-')[0];
  const copy = translations[locale] || translations.en;

  function setText(root, selector, value) {
    const element = root.querySelector(selector);
    if (element && element.textContent.trim() !== value) {
      element.textContent = value;
    }
  }

  function setPlaceholder(root, selector, value) {
    const input = root.querySelector(selector);
    if (input && input.getAttribute('placeholder') !== value) {
      input.setAttribute('placeholder', value);
      input.setAttribute('aria-label', value);
    }
  }

  function translateWidget() {
    const root = document.querySelector('#yq-trackingBox');
    if (!root) return;

    setText(root, '.yq-tracking-title, .yq-title, h1, h2, h3', copy.title);

    setText(root, '.yq-track-tab-order-num', copy.orderTab);
    setText(root, '.yq-track-tab-tracking-num', copy.trackingTab);

    const inputs = [...root.querySelectorAll('input')];
    const emailInput = inputs.find((input) =>
      input.type === 'email' ||
      /mail/i.test(input.name || '') ||
      /mail/i.test(input.placeholder || '') ||
      /邮箱/.test(input.placeholder || '')
    );
    const orderInput = inputs.find((input) =>
      input !== emailInput &&
      (/order/i.test(input.name || '') ||
       /订单/i.test(input.placeholder || ''))
    );
    const trackingInput = inputs.find((input) =>
      input !== emailInput &&
      input !== orderInput &&
      (/track|logistic|tracking/i.test(input.name || '') ||
       /物流/i.test(input.placeholder || ''))
    );

    if (orderInput) {
      orderInput.placeholder = copy.orderPlaceholder;
      orderInput.setAttribute('aria-label', copy.orderPlaceholder);
    }
    if (emailInput) {
      emailInput.placeholder = copy.emailPlaceholder;
      emailInput.setAttribute('aria-label', copy.emailPlaceholder);
    }
    if (trackingInput) {
      trackingInput.placeholder = copy.trackingPlaceholder;
      trackingInput.setAttribute('aria-label', copy.trackingPlaceholder);
    }

    setPlaceholder(root, 'input[type="email"]', copy.emailPlaceholder);
    const emailType = root.querySelector('.ant-select-selection-item');
    if (emailType && /邮箱|email|e-mail/i.test(emailType.textContent.trim())) {
      emailType.textContent = copy.emailPlaceholder;
      emailType.setAttribute('title', copy.emailPlaceholder);
    }

    root.querySelectorAll('div, span').forEach((element) => {
      if (element.childElementCount === 0 && element.textContent.trim() === '查询中...') {
        element.textContent = copy.loading;
      }
    });

    root.querySelectorAll('button').forEach((button) => {
      const text = button.textContent.trim();
      if (/查询|查\s*询|track|traccia|suivre|verfolgen|rastrear/i.test(text)) {
        button.textContent = copy.button;
        button.setAttribute('aria-label', copy.button);
      } else if (/查询中|searching|loading/i.test(text)) {
        button.textContent = copy.loading;
      }
    });
  }

  let scheduled = false;
  const scheduleTranslation = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      translateWidget();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleTranslation, { once: true });
  } else {
    scheduleTranslation();
  }

  new MutationObserver(scheduleTranslation).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
